import { list_url } from "@project/sharedcomponents/apiURL"
import { common_setGSTSummaryData } from "@project/sharedcomponents/reportFunction"
import { getAxiosCancelToken, getCatchErrorMessage, isblank, setAxiosCancelToken } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { getAccountSitesetting, getheaders, handleResponse, postErrorOnException } from "../Lib/commonfunctions"
import {
  GST_OLD_PEN_INV_SEARCH_TEXT_UPDATE,
  GST_OLD_PEN_INV_SERVICE_CLEAR,
  GST_OLD_PEN_INV_SERVICE_FAIL,
  GST_OLD_PEN_INV_SERVICE_START,
  GST_OLD_PEN_INV_SERVICE_SUCCESS,
  LOADING_STATE,
  SNACKBAR_STATE,
} from "./types"

export const gstOldPenIn_data_clear = () => {
  return (dispatch) => {
    dispatch({
      type: GST_OLD_PEN_INV_SERVICE_CLEAR,
    })
  }
}
export const gstOldPenInsearch_change = ({ search_text }) => {
  return (dispatch) => {
    dispatch({
      type: GST_OLD_PEN_INV_SEARCH_TEXT_UPDATE,
      search_text: search_text,
    })
  }
}
export const fetch_gstOldPenIn_data = ({ rowsPerPage, page, order, orderBy, search_text, functions }) => {
  if (isblank(rowsPerPage)) {
    rowsPerPage = getAccountSitesetting("pagination_size")
  }
  return (dispatch) => {
    if (typeof getAxiosCancelToken() != typeof undefined) {
      getAxiosCancelToken().cancel("Operation canceled due to new request.")
    }
    // save the new request for cancellation
    setAxiosCancelToken(axios.CancelToken.source())
    dispatch({ type: GST_OLD_PEN_INV_SERVICE_START })
    dispatch({ type: LOADING_STATE, state: true })

    let data = new FormData()
    data.append("offset", page * rowsPerPage)
    data.append("type", "gstoldbill")
    data.append("limit", rowsPerPage)
    data.append("sort_order", order)
    data.append("sort_by", orderBy)
    data.append("search_text", search_text)
    data.append("other_type", "all")

    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "gstoldbill" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      cancelToken: getAxiosCancelToken().token,
      data: data,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          gstOldPenInServiceFail({ dispatch, response: response.data.meta.message, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          response = common_setGSTSummaryData({ response, functions })
          gstOldPenInServiceSuccess({ dispatch, user: response, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          postErrorOnException(error)
          gstOldPenInServiceFail({ dispatch, response: getCatchErrorMessage(error), rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
  }
}

const gstOldPenInServiceSuccess = ({ dispatch, user, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: GST_OLD_PEN_INV_SERVICE_SUCCESS,
    payload: user,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}

const gstOldPenInServiceFail = ({ dispatch, response, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })
  dispatch({
    type: GST_OLD_PEN_INV_SERVICE_FAIL,
    payload: response,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}
